module.exports = __webpack_public_path__ + "assets/media/birthday.21396097.mp3";